import { render, staticRenderFns } from "./GratisTicketsListContainer.vue?vue&type=template&id=5bfca36e&scoped=true"
import script from "./GratisTicketsListContainer.vue?vue&type=script&lang=js"
export * from "./GratisTicketsListContainer.vue?vue&type=script&lang=js"
import style0 from "./GratisTicketsListContainer.vue?vue&type=style&index=0&id=5bfca36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfca36e",
  null
  
)

export default component.exports